import Tracking from './tracking';
import Search from './search';

const raceTracking = {
    init() {
        // Das Event wird getriggert wenn Cookies akzeptiert werden
        window.addEventListener('initRaceTracking', () => {
            const tracking = new Tracking();
            tracking.init();
            const search = new Search();
            search.init();
        });
    },
};

export default raceTracking;
